import { forwardRef, type Ref, type SVGProps } from "react";
const IconHOAOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m21.65 6.47-5-4.23a1 1 0 0 0-1.3 0l-5 4.23a1 1 0 0 0-.35.76v6.27a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5V7.23a1 1 0 0 0-.35-.76M20 13h-3v-2a1 1 0 0 0-2 0v2h-3V7.69l4-3.38 4 3.38z" />
    <path d="m14.31 20.81-3.94-4.75-.09-.1A2.9 2.9 0 0 0 8 15.2v-2.7C8 9.92 6.38 9 5 9s-3 1.08-3 3.5v7.2a3.74 3.74 0 0 0 .82 2.3L7 27.25V29a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6.28a3 3 0 0 0-.69-1.91M13 28H9v-1.1a1 1 0 0 0-.22-.62l-4.4-5.51A1.67 1.67 0 0 1 4 19.7v-7.2c0-.68.17-1.5 1-1.5.25 0 1 0 1 1.5v3.85A3 3 0 0 0 6.23 20l3 3.6a1 1 0 0 0 1.54-1.28l-3-3.64a1 1 0 0 1-.06-1.28.86.86 0 0 1 1.2 0l3.89 4.68a1 1 0 0 1 .23.64zM27 9c-1.38 0-3 .92-3 3.5v2.69a2.93 2.93 0 0 0-2.28.77l-.09.1-3.94 4.75a3 3 0 0 0-.69 1.91V29a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1.75L29.18 22a3.74 3.74 0 0 0 .82-2.3v-7.2c0-2.42-1.51-3.5-3-3.5m1 10.7a1.7 1.7 0 0 1-.38 1.08l-4.4 5.5a1 1 0 0 0-.22.62V28h-4v-5.28a1 1 0 0 1 .23-.64l3.89-4.68a.84.84 0 0 1 1.14 0 1 1 0 0 1 0 1.38l-3 3.6a1 1 0 1 0 1.54 1.28l3-3.56a3 3 0 0 0 .2-3.73V12.5c0-1.5.75-1.5 1-1.5.83 0 1 .82 1 1.5z" />
  </svg>
);
const ForwardRef = forwardRef(IconHOAOutlineSVG);
ForwardRef.displayName = "IconHOAOutline";
export { ForwardRef as IconHOAOutline };
